import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="min-h-[70vh] flex items-center">
      <Seo title="Not found · AUT labs" description="This page doesn't exist." />
      <div className="mx-auto max-w-[1400px] w-full px-5 md:px-8">
        <p className="eyebrow mb-6">404</p>
        <h1 className="display text-[40px] md:text-[80px] leading-[0.98] max-w-3xl">
          That page isn't here. Nothing floats around here.
        </h1>
        <Link to="/" className="pill pill-cobalt mt-10" data-testid="notfound-home-btn">
          Back home
        </Link>
      </div>
    </div>
  );
}
